/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * Tayyibati API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminStats,
  AdminUser,
  AnalysisReport,
  BulkFoodInput,
  BulkFoodResult,
  Food,
  FoodInput,
  FoodStats,
  FoodUpdate,
  GetUserUsageParams,
  HealthStatus,
  HistoryItem,
  ImageAnalysisInput,
  ListAdminHistoryParams,
  ListFoodsParams,
  ListHistoryParams,
  TextAnalysisInput,
  UserUsage
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListFoodsUrl = (params?: ListFoodsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/foods?${stringifiedParams}` : `/api/foods`
}

/**
 * @summary List foods
 */
export const listFoods = async (params?: ListFoodsParams, options?: RequestInit): Promise<Food[]> => {

  return customFetch<Food[]>(getListFoodsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListFoodsQueryKey = (params?: ListFoodsParams,) => {
    return [
    `/api/foods`, ...(params ? [params] : [])
    ] as const;
    }


export const getListFoodsQueryOptions = <TData = Awaited<ReturnType<typeof listFoods>>, TError = ErrorType<unknown>>(params?: ListFoodsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFoods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFoodsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFoods>>> = ({ signal }) => listFoods(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFoods>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFoodsQueryResult = NonNullable<Awaited<ReturnType<typeof listFoods>>>
export type ListFoodsQueryError = ErrorType<unknown>


/**
 * @summary List foods
 */

export function useListFoods<TData = Awaited<ReturnType<typeof listFoods>>, TError = ErrorType<unknown>>(
 params?: ListFoodsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFoods>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFoodsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateFoodUrl = () => {




  return `/api/foods`
}

/**
 * @summary Create a food entry (admin)
 */
export const createFood = async (foodInput: FoodInput, options?: RequestInit): Promise<Food> => {

  return customFetch<Food>(getCreateFoodUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      foodInput,)
  }
);}




export const getCreateFoodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFood>>, TError,{data: BodyType<FoodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFood>>, TError,{data: BodyType<FoodInput>}, TContext> => {

const mutationKey = ['createFood'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFood>>, {data: BodyType<FoodInput>}> = (props) => {
          const {data} = props ?? {};

          return  createFood(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFoodMutationResult = NonNullable<Awaited<ReturnType<typeof createFood>>>
    export type CreateFoodMutationBody = BodyType<FoodInput>
    export type CreateFoodMutationError = ErrorType<unknown>

    /**
 * @summary Create a food entry (admin)
 */
export const useCreateFood = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFood>>, TError,{data: BodyType<FoodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createFood>>,
        TError,
        {data: BodyType<FoodInput>},
        TContext
      > => {
      return useMutation(getCreateFoodMutationOptions(options));
    }

export const getBulkCreateFoodsUrl = () => {




  return `/api/foods/bulk`
}

/**
 * @summary Bulk create food entries (admin)
 */
export const bulkCreateFoods = async (bulkFoodInput: BulkFoodInput, options?: RequestInit): Promise<BulkFoodResult> => {

  return customFetch<BulkFoodResult>(getBulkCreateFoodsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkFoodInput,)
  }
);}




export const getBulkCreateFoodsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateFoods>>, TError,{data: BodyType<BulkFoodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateFoods>>, TError,{data: BodyType<BulkFoodInput>}, TContext> => {

const mutationKey = ['bulkCreateFoods'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateFoods>>, {data: BodyType<BulkFoodInput>}> = (props) => {
          const {data} = props ?? {};

          return  bulkCreateFoods(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateFoodsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateFoods>>>
    export type BulkCreateFoodsMutationBody = BodyType<BulkFoodInput>
    export type BulkCreateFoodsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk create food entries (admin)
 */
export const useBulkCreateFoods = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateFoods>>, TError,{data: BodyType<BulkFoodInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateFoods>>,
        TError,
        {data: BodyType<BulkFoodInput>},
        TContext
      > => {
      return useMutation(getBulkCreateFoodsMutationOptions(options));
    }

export const getGetFoodUrl = (id: number,) => {




  return `/api/foods/${id}`
}

/**
 * @summary Get a food by id
 */
export const getFood = async (id: number, options?: RequestInit): Promise<Food> => {

  return customFetch<Food>(getGetFoodUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFoodQueryKey = (id: number,) => {
    return [
    `/api/foods/${id}`
    ] as const;
    }


export const getGetFoodQueryOptions = <TData = Awaited<ReturnType<typeof getFood>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFoodQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFood>>> = ({ signal }) => getFood(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFoodQueryResult = NonNullable<Awaited<ReturnType<typeof getFood>>>
export type GetFoodQueryError = ErrorType<unknown>


/**
 * @summary Get a food by id
 */

export function useGetFood<TData = Awaited<ReturnType<typeof getFood>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFoodQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateFoodUrl = (id: number,) => {




  return `/api/foods/${id}`
}

/**
 * @summary Update a food entry (admin)
 */
export const updateFood = async (id: number,
    foodUpdate: FoodUpdate, options?: RequestInit): Promise<Food> => {

  return customFetch<Food>(getUpdateFoodUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      foodUpdate,)
  }
);}




export const getUpdateFoodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFood>>, TError,{id: number;data: BodyType<FoodUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFood>>, TError,{id: number;data: BodyType<FoodUpdate>}, TContext> => {

const mutationKey = ['updateFood'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFood>>, {id: number;data: BodyType<FoodUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFood(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFoodMutationResult = NonNullable<Awaited<ReturnType<typeof updateFood>>>
    export type UpdateFoodMutationBody = BodyType<FoodUpdate>
    export type UpdateFoodMutationError = ErrorType<unknown>

    /**
 * @summary Update a food entry (admin)
 */
export const useUpdateFood = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFood>>, TError,{id: number;data: BodyType<FoodUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateFood>>,
        TError,
        {id: number;data: BodyType<FoodUpdate>},
        TContext
      > => {
      return useMutation(getUpdateFoodMutationOptions(options));
    }

export const getDeleteFoodUrl = (id: number,) => {




  return `/api/foods/${id}`
}

/**
 * @summary Delete a food (admin)
 */
export const deleteFood = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteFoodUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteFoodMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFood>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFood>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteFood'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFood>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFood(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFoodMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFood>>>

    export type DeleteFoodMutationError = ErrorType<unknown>

    /**
 * @summary Delete a food (admin)
 */
export const useDeleteFood = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFood>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFood>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteFoodMutationOptions(options));
    }

export const getGetFoodStatsUrl = () => {




  return `/api/foods/stats`
}

/**
 * @summary Get database statistics
 */
export const getFoodStats = async ( options?: RequestInit): Promise<FoodStats> => {

  return customFetch<FoodStats>(getGetFoodStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFoodStatsQueryKey = () => {
    return [
    `/api/foods/stats`
    ] as const;
    }


export const getGetFoodStatsQueryOptions = <TData = Awaited<ReturnType<typeof getFoodStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFoodStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFoodStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFoodStats>>> = ({ signal }) => getFoodStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFoodStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFoodStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getFoodStats>>>
export type GetFoodStatsQueryError = ErrorType<unknown>


/**
 * @summary Get database statistics
 */

export function useGetFoodStats<TData = Awaited<ReturnType<typeof getFoodStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFoodStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFoodStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAnalyzeTextUrl = () => {




  return `/api/analysis/text`
}

/**
 * @summary Analyze food by text description
 */
export const analyzeText = async (textAnalysisInput: TextAnalysisInput, options?: RequestInit): Promise<AnalysisReport> => {

  return customFetch<AnalysisReport>(getAnalyzeTextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      textAnalysisInput,)
  }
);}




export const getAnalyzeTextMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeText>>, TError,{data: BodyType<TextAnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeText>>, TError,{data: BodyType<TextAnalysisInput>}, TContext> => {

const mutationKey = ['analyzeText'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeText>>, {data: BodyType<TextAnalysisInput>}> = (props) => {
          const {data} = props ?? {};

          return  analyzeText(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeTextMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeText>>>
    export type AnalyzeTextMutationBody = BodyType<TextAnalysisInput>
    export type AnalyzeTextMutationError = ErrorType<unknown>

    /**
 * @summary Analyze food by text description
 */
export const useAnalyzeText = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeText>>, TError,{data: BodyType<TextAnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeText>>,
        TError,
        {data: BodyType<TextAnalysisInput>},
        TContext
      > => {
      return useMutation(getAnalyzeTextMutationOptions(options));
    }

export const getAnalyzeImageUrl = () => {




  return `/api/analysis/image`
}

/**
 * @summary Analyze food by image (base64)
 */
export const analyzeImage = async (imageAnalysisInput: ImageAnalysisInput, options?: RequestInit): Promise<AnalysisReport> => {

  return customFetch<AnalysisReport>(getAnalyzeImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      imageAnalysisInput,)
  }
);}




export const getAnalyzeImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeImage>>, TError,{data: BodyType<ImageAnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeImage>>, TError,{data: BodyType<ImageAnalysisInput>}, TContext> => {

const mutationKey = ['analyzeImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeImage>>, {data: BodyType<ImageAnalysisInput>}> = (props) => {
          const {data} = props ?? {};

          return  analyzeImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeImageMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeImage>>>
    export type AnalyzeImageMutationBody = BodyType<ImageAnalysisInput>
    export type AnalyzeImageMutationError = ErrorType<unknown>

    /**
 * @summary Analyze food by image (base64)
 */
export const useAnalyzeImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeImage>>, TError,{data: BodyType<ImageAnalysisInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeImage>>,
        TError,
        {data: BodyType<ImageAnalysisInput>},
        TContext
      > => {
      return useMutation(getAnalyzeImageMutationOptions(options));
    }

export const getListHistoryUrl = (params?: ListHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/history?${stringifiedParams}` : `/api/history`
}

/**
 * @summary List user analysis history
 */
export const listHistory = async (params?: ListHistoryParams, options?: RequestInit): Promise<HistoryItem[]> => {

  return customFetch<HistoryItem[]>(getListHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListHistoryQueryKey = (params?: ListHistoryParams,) => {
    return [
    `/api/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listHistory>>, TError = ErrorType<unknown>>(params?: ListHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHistory>>> = ({ signal }) => listHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listHistory>>>
export type ListHistoryQueryError = ErrorType<unknown>


/**
 * @summary List user analysis history
 */

export function useListHistory<TData = Awaited<ReturnType<typeof listHistory>>, TError = ErrorType<unknown>>(
 params?: ListHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAdminHistoryUrl = (params?: ListAdminHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/history?${stringifiedParams}` : `/api/admin/history`
}

/**
 * @summary List all analysis history (admin)
 */
export const listAdminHistory = async (params?: ListAdminHistoryParams, options?: RequestInit): Promise<HistoryItem[]> => {

  return customFetch<HistoryItem[]>(getListAdminHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminHistoryQueryKey = (params?: ListAdminHistoryParams,) => {
    return [
    `/api/admin/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminHistoryQueryOptions = <TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ErrorType<unknown>>(params?: ListAdminHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminHistory>>> = ({ signal }) => listAdminHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminHistory>>>
export type ListAdminHistoryQueryError = ErrorType<unknown>


/**
 * @summary List all analysis history (admin)
 */

export function useListAdminHistory<TData = Awaited<ReturnType<typeof listAdminHistory>>, TError = ErrorType<unknown>>(
 params?: ListAdminHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminHistory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAdminStatsUrl = () => {




  return `/api/admin/stats`
}

/**
 * @summary Get admin analytics stats
 */
export const getAdminStats = async ( options?: RequestInit): Promise<AdminStats> => {

  return customFetch<AdminStats>(getGetAdminStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminStatsQueryKey = () => {
    return [
    `/api/admin/stats`
    ] as const;
    }


export const getGetAdminStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStats>>> = ({ signal }) => getAdminStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStats>>>
export type GetAdminStatsQueryError = ErrorType<unknown>


/**
 * @summary Get admin analytics stats
 */

export function useGetAdminStats<TData = Awaited<ReturnType<typeof getAdminStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetHistoryItemUrl = (id: number,) => {




  return `/api/history/${id}`
}

/**
 * @summary Get a history item
 */
export const getHistoryItem = async (id: number, options?: RequestInit): Promise<HistoryItem> => {

  return customFetch<HistoryItem>(getGetHistoryItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHistoryItemQueryKey = (id: number,) => {
    return [
    `/api/history/${id}`
    ] as const;
    }


export const getGetHistoryItemQueryOptions = <TData = Awaited<ReturnType<typeof getHistoryItem>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHistoryItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHistoryItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHistoryItem>>> = ({ signal }) => getHistoryItem(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHistoryItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHistoryItemQueryResult = NonNullable<Awaited<ReturnType<typeof getHistoryItem>>>
export type GetHistoryItemQueryError = ErrorType<unknown>


/**
 * @summary Get a history item
 */

export function useGetHistoryItem<TData = Awaited<ReturnType<typeof getHistoryItem>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHistoryItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHistoryItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteHistoryItemUrl = (id: number,) => {




  return `/api/history/${id}`
}

/**
 * @summary Delete a history item
 */
export const deleteHistoryItem = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteHistoryItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteHistoryItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHistoryItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHistoryItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteHistoryItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHistoryItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteHistoryItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteHistoryItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHistoryItem>>>

    export type DeleteHistoryItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete a history item
 */
export const useDeleteHistoryItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHistoryItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteHistoryItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteHistoryItemMutationOptions(options));
    }

export const getGetUserUsageUrl = (params: GetUserUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/usage?${stringifiedParams}` : `/api/users/usage`
}

/**
 * @summary Get user daily usage count
 */
export const getUserUsage = async (params: GetUserUsageParams, options?: RequestInit): Promise<UserUsage> => {

  return customFetch<UserUsage>(getGetUserUsageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserUsageQueryKey = (params?: GetUserUsageParams,) => {
    return [
    `/api/users/usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserUsageQueryOptions = <TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ErrorType<unknown>>(params: GetUserUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserUsage>>> = ({ signal }) => getUserUsage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getUserUsage>>>
export type GetUserUsageQueryError = ErrorType<unknown>


/**
 * @summary Get user daily usage count
 */

export function useGetUserUsage<TData = Awaited<ReturnType<typeof getUserUsage>>, TError = ErrorType<unknown>>(
 params: GetUserUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserUsageQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUnlockUserUrl = (id: string,) => {




  return `/api/users/${id}/unlock`
}

/**
 * @summary Unlock a locked user account (admin)
 */
export const unlockUser = async (id: string, options?: RequestInit): Promise<AdminUser> => {

  return customFetch<AdminUser>(getUnlockUserUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnlockUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unlockUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['unlockUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unlockUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockUserMutationResult = NonNullable<Awaited<ReturnType<typeof unlockUser>>>

    export type UnlockUserMutationError = ErrorType<void>

    /**
 * @summary Unlock a locked user account (admin)
 */
export const useUnlockUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unlockUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnlockUserMutationOptions(options));
    }

